function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMccGoods = function SvgMccGoods(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h32a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H4Zm0 9h32v17a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V14Zm10 7a2 2 0 0 1 2-2h8a2 2 0 1 1 0 4h-8a2 2 0 0 1-2-2Z",
    clipRule: "evenodd",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccGoods;